import { ClientRepo as clientRepo } from "@services/clients/client.repo";
import { ClientCRMRepo as clientCRMRepo } from "@services/clients/clientCRM.repo";
import { DropdownOptionsService } from "@services/clients/dropdownOptions.service";
import { ClientFilters } from "./modals/clients-filter-modal.component";
import { AuthService } from "@common/auth.service";
import { extractErrorMessage } from "@common/utils/errorUtils";


class ClientsController implements angular.IOnInit {
  static $inject = [
    "clientRepo",
    "clientCRMRepo",
    "dropdownOptionsService",
    "$scope",
    "$cookies",
    "$state",
    "ModalService",
    "$timeout",
    "$mdDialog",
    "$rootScope",
    "authService",
    "notifyjs",
  ];

  public username: any;
  public searchTerm: any;
  public searchColumn: any;
  public orderColumn: any;
  public orderDirection: any;
  public gridOptions: any;
  public page: any;
  public itemsPerPage: any;
  public displayMyClients: boolean;
  public isLoading: boolean = false;
  public isExtractingPep: boolean = false;
  public displayActive: boolean = true;
  /** Table dropdown: 'active' | 'inactive' | 'all' - sent to API as ActiveStatusFilter. */
  public activeStatusFilter: "active" | "inactive" | "all" = "active";
  public displayInstitutions: boolean = true;
  public displayIndividuals: boolean = true;
  public hasTradeRestrictions: boolean = false;
  public selectedGeographicalLocations: number[] = [];
  public selectedProfessionalActivities: number[] = [];
  public selectedSecurityRestrictions: number[] = [];

  // Column width configuration - single source of truth
  public columnWidths = {
    clientType: '5%',
    clientNumber: '10%',
    name: '25%',
    status: '10%',
    owner: '15%',
    manager: '15%',
    admin: '15%',
    actions: '5%'
  };

  // Column widths for the ClientDetailsViewOnly role (fewer columns)
  public viewOnlyColumnWidths = {
    clientType: '4%',
    name: '20%',
    owner: '14%',
    manager: '14%',
    admin: '14%',
    email: '17%',
    mobile: '17%'
  };

  public get activeColumnWidths() {
    return this.isClientDetailsViewOnly() ? this.viewOnlyColumnWidths : this.columnWidths;
  }

  public getTableColspan(): number {
    return this.isClientDetailsViewOnly() ? 7 : 8;
  }

  private selectedInvestmentOfficers: any[] = [];
  private InvestmentOfficerOptions: any;

  private selectedPortfolioManagers: any[] = [];
  private PortfolioManagerOptions: any;

  private selectedAdministrativeOfficers: any[] = [];
  private AdministrativeOfficerOptions: any;

  /** @ngInject */
  constructor(
    private clientRepo: clientRepo,
    private clientCRMRepo: clientCRMRepo,
    private dropdownOptionsService: DropdownOptionsService,
    private $scope: angular.IScope,
    private $cookies: angular.cookies.ICookiesService,
    private $state: angular.ui.IStateService,
    private ModalService: any,
    private $timeout: angular.ITimeoutService,
    private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService,
    private authService: AuthService,
    private notifyjs: any
  ) {
    let that = this;
    this.$timeout(function () {
      if (!localStorage.getItem("itemsPerPage")) {
        that.itemsPerPage = 10;
        localStorage.setItem("itemsPerPage", that.itemsPerPage);
      }
      if (!localStorage.getItem("currentPage")) {
        that.page = 1;
        localStorage.setItem("currentPage", that.page);
      }

      if (!localStorage.getItem("searchTerm")) {
        that.searchTerm = "";
        localStorage.setItem("searchTerm", that.searchTerm);
      }

      that.page = localStorage.getItem("currentPage");
      that.gridOptions.grid.paginationOptions.currentPage = that.page;

      that.itemsPerPage = localStorage.getItem("itemsPerPage");
      that.gridOptions.grid.paginationOptions.itemsPerPage = that.itemsPerPage;

      that.searchTerm = localStorage.getItem("searchTerm");

      that.displayMyClients = localStorage.getItem("displayMyClients") === "true";
      that.displayActive = localStorage.getItem("displayActive") === "true";
      const savedActiveStatusFilter = localStorage.getItem("activeStatusFilter");
      that.activeStatusFilter = (savedActiveStatusFilter === "active" || savedActiveStatusFilter === "inactive" || savedActiveStatusFilter === "all")
        ? savedActiveStatusFilter
        : (that.displayActive ? "active" : "inactive");
      that.displayInstitutions = localStorage.getItem("displayInstitutions") !== "false"; // Default to true if not set
      that.displayIndividuals = localStorage.getItem("displayIndividuals") !== "false"; // Default to true if not set
      
      // Load geographical location and professional activity filters
      const savedGeographicalLocations = localStorage.getItem("selectedGeographicalLocations");
      that.selectedGeographicalLocations = savedGeographicalLocations ? JSON.parse(savedGeographicalLocations) : [];
      
      const savedProfessionalActivities = localStorage.getItem("selectedProfessionalActivities");
      that.selectedProfessionalActivities = savedProfessionalActivities ? JSON.parse(savedProfessionalActivities) : [];

      // Load security restrictions and has trade restrictions filters
      const savedSecurityRestrictions = localStorage.getItem("selectedSecurityRestrictions");
      that.selectedSecurityRestrictions = savedSecurityRestrictions ? JSON.parse(savedSecurityRestrictions) : [];
      
      const savedHasTradeRestrictions = localStorage.getItem("hasTradeRestrictions");
      that.hasTradeRestrictions = savedHasTradeRestrictions === "true";

      that.tableSearchOrFilter(false);
    }, 1000);
  }

  $onInit() {
    this.$scope["actions"] = {};
    this.gridOptions = this.$scope["options"] = {
      urlSync: true,
      data: [],
      sort: {
        predicate: "name",
        direction: "asc",
      },
      getData: this.retrieveClientData.bind(this),
    };
  }

  private retrieveClientData(params, callback) {
    this.isLoading = true;
    let that = this;
    if (!localStorage.getItem("itemsPerPage")) {
      that.itemsPerPage = 10;
      localStorage.setItem("itemsPerPage", that.itemsPerPage);
    }
    if (!localStorage.getItem("currentPage")) {
      that.page = 1;
      localStorage.setItem("currentPage", that.page);
    }
    if (!localStorage.getItem("searchTerm")) {
      that.searchTerm = "";
      localStorage.setItem("searchTerm", that.searchTerm);
    }

    that.page = localStorage.getItem("currentPage");
    that.gridOptions.grid.paginationOptions.currentPage = that.page;

    that.itemsPerPage = localStorage.getItem("itemsPerPage");
    that.gridOptions.grid.paginationOptions.itemsPerPage = that.itemsPerPage;

    that.searchTerm = localStorage.getItem("searchTerm");

    if (localStorage.getItem("displayMyClients") === "true") {
      this.displayMyClients = true;
    } else {
      this.displayMyClients = false;
    }

    // displayActive / activeStatusFilter
    const savedActiveStatusFilter = localStorage.getItem("activeStatusFilter");
    if (savedActiveStatusFilter === "active" || savedActiveStatusFilter === "inactive" || savedActiveStatusFilter === "all") {
      this.activeStatusFilter = savedActiveStatusFilter;
      this.displayActive = savedActiveStatusFilter !== "inactive";
    } else if (localStorage.getItem("displayActive") === "true") {
      this.displayActive = true;
      this.activeStatusFilter = "active";
    } else {
      this.displayActive = false;
      this.activeStatusFilter = "inactive";
    }

    // displayInstitutions
    if (localStorage.getItem("displayInstitutions") === "false") {
      this.displayInstitutions = false;
    } else {
      this.displayInstitutions = true; // Default to true if not set
    }

    // displayIndividuals
    if (localStorage.getItem("displayIndividuals") === "false") {
      this.displayIndividuals = false;
    } else {
      this.displayIndividuals = true; // Default to true if not set
    }


    this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
    this.orderDirection = this.gridOptions.grid.sortOptions.direction;

    console.log('selectedGeographicalLocations', this.selectedGeographicalLocations);
    console.log('selectedProfessionalActivities', this.selectedProfessionalActivities);
    this.clientRepo
      .searchClients({
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        searchText: this.searchTerm,
        searchColumn: this.searchColumn,
        orderColumn: this.orderColumn,
        orderDirection: this.orderDirection,
        displayAllClients: !this.displayMyClients, // Invert logic: when "Only My Clients" is ON, displayAllClients should be FALSE
        selectedInvestmentOfficers: this.selectedInvestmentOfficers,
        selectedPortfolioManagers: this.selectedPortfolioManagers,
        selectedAdministrativeOfficers: this.selectedAdministrativeOfficers,
        selectedGeographicalLocations: this.selectedGeographicalLocations,
        selectedProfessionalActivities: this.selectedProfessionalActivities,
        selectedSecurityRestrictions: this.selectedSecurityRestrictions,
        hasTradeRestrictions: this.hasTradeRestrictions,
        activeStatusFilter: this.isClientDetailsViewOnly() ? "Active" : this.getActiveStatusFilterForApi(),
        displayActiveClients: this.isClientDetailsViewOnly() ? true : this.displayActive,
        displayInstitutions: this.displayInstitutions,
        displayIndividuals: this.displayIndividuals
      })
      .then((val) => {
        let clientList: any = val.data;
        let data = this.processResults(val);
        callback(data, clientList.count);
      })
      .catch(() => {
        this.notifyjs("Failed to load clients. Please try again.", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private processResults(results) {
    let clientList: any = results.data;
    let data = [];
    this.setOfficerAndManagerFilterOptions(results);

    // Process the client data
    for (var c of clientList.results) {
      let clientItem = {
        clientNumber: c.clientNumber,
        name: c.name,
        status: c.status,
        owner: c.owner,
        manager: c.relationshipManager,
        administeredBy: c.administrativeOfficer,
        clientType: c.clientType,
        emailAddress: c.emailAddress,
        mobilePhone: c.mobilePhone,
      };

      data.push(clientItem);
    }

    return data;
  }

  public refresh() {
    this.isLoading = true;
    this.page = this.gridOptions.grid.paginationOptions.currentPage;
    this.itemsPerPage = this.gridOptions.grid.paginationOptions.itemsPerPage;
    this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
    this.orderDirection = this.gridOptions.grid.sortOptions.direction;

    this.clientRepo
      .refreshClients(
        this.page,
        this.itemsPerPage,
        this.searchTerm,
        this.searchColumn,
        this.orderColumn,
        this.orderDirection,
        !this.displayMyClients, // Invert logic: when "Only My Clients" is ON, displayAllClients should be FALSE
        this.selectedInvestmentOfficers,
        this.selectedPortfolioManagers,
        this.selectedAdministrativeOfficers,
        this.selectedGeographicalLocations,
        this.selectedProfessionalActivities,
        this.selectedSecurityRestrictions,
        this.hasTradeRestrictions,
        this.displayActive,
        this.displayInstitutions,
        this.displayIndividuals
      )
      .then((val: angular.IHttpPromiseCallbackArg<any>) => {
        this.gridOptions.grid.filtered = this.processResults(val);
        this.gridOptions.grid.paginationOptions.currentPage = 1;
        this.gridOptions.grid.paginationOptions.totalItems = val.data.count;
      })
      .catch(() => {
        this.notifyjs("Failed to load clients. Please try again.", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  // Both the search and the filter on the page trigger this function to retrieve the correct list of clients:

  // Angular Data Grid (grid-data) does not do client side filtering if server-pagination="true".
  // Instead it tries to change the path by adding the selected items to be sent to the server for filtering.
  // The path it changes is not the path that we send, so the filter information is now being sent by us, using this function.
  public tableSearchOrFilter(isSearchOrFilter: boolean = false) {
    this.isLoading = true;
    localStorage.setItem("searchTerm", this.searchTerm);
    // setting the page and item numbers to a default number because you can get stuck on a different page and results will not be shown.
    if (isSearchOrFilter) {
      this.page = 1;
      this.gridOptions.grid.paginationOptions.currentPage = this.page;
      this.itemsPerPage = this.gridOptions.grid.paginationOptions.itemsPerPage;
      this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
      this.orderDirection = this.gridOptions.grid.sortOptions.direction;
    } else {
      this.page = this.gridOptions.grid.paginationOptions.currentPage;
      this.itemsPerPage = this.gridOptions.grid.paginationOptions.itemsPerPage;
      this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
      this.orderDirection = this.gridOptions.grid.sortOptions.direction;
    }

    this.clientRepo
      .searchClients({
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        searchText: this.searchTerm,
        searchColumn: this.searchColumn,
        orderColumn: this.orderColumn,
        orderDirection: this.orderDirection,
        displayAllClients: !this.displayMyClients, // Invert logic: when "Only My Clients" is ON, displayAllClients should be FALSE
        selectedInvestmentOfficers: this.selectedInvestmentOfficers,
        selectedPortfolioManagers: this.selectedPortfolioManagers,
        selectedAdministrativeOfficers: this.selectedAdministrativeOfficers,
        selectedGeographicalLocations: this.selectedGeographicalLocations,
        selectedProfessionalActivities: this.selectedProfessionalActivities,
        selectedSecurityRestrictions: this.selectedSecurityRestrictions,
        hasTradeRestrictions: this.hasTradeRestrictions,
        activeStatusFilter: this.isClientDetailsViewOnly() ? "Active" : this.getActiveStatusFilterForApi(),
        displayActiveClients: this.isClientDetailsViewOnly() ? true : this.displayActive,
        displayInstitutions: this.displayInstitutions,
        displayIndividuals: this.displayIndividuals
      })
      .then((val: angular.IHttpPromiseCallbackArg<any>) => {
        if (val.data.results.length == 0 && this.page > 1) {
          // Only retry if we're not already on page 1 to prevent infinite recursion
          this.page = 1;
          this.gridOptions.grid.paginationOptions.currentPage = this.page;
          localStorage.setItem(
            "currentPage",
            this.gridOptions.grid.paginationOptions.currentPage
          );
          this.tableSearchOrFilter(false);
        } else {
          // Either we have results OR we're already on page 1 with no results
          this.gridOptions.grid.filtered = this.processResults(val);
          this.gridOptions.grid.paginationOptions.totalItems = val.data.count;
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.notifyjs("Failed to load clients. Please try again.", "error");
        this.isLoading = false;
      });
  }

  // Set the InvestmentOfficerOptions and PortfolioManagerOptions so that we can populate the multi-selects in the table
  // with all the names of the investment officers and the portfolio managers:
  private setOfficerAndManagerFilterOptions(results) {
    this.InvestmentOfficerOptions = [];
    this.PortfolioManagerOptions = [];
    this.AdministrativeOfficerOptions = [];

    for (var name of results.data.investmentOfficerOptions) {
      if (name != null && name != "") {
        let investmentOfficerItem = {
          name: name,
        };
        this.InvestmentOfficerOptions.push(investmentOfficerItem);
      }
    }

    for (var name of results.data.portfolioManagerOptions) {
      if (name != null && name != "") {
        let portfolioManagerItem = {
          name: name,
        };
        this.PortfolioManagerOptions.push(portfolioManagerItem);
      }
    }

    for (var name of results.data.administrativeOfficerOptions) {
      if (name != null && name != "") {
        let administrativeOfficerItem = {
          name: name,
        };
        this.AdministrativeOfficerOptions.push(administrativeOfficerItem);
      }
    }
  }

  public getPortfolioManagerOptions(results) {
    return this.PortfolioManagerOptions;
  }

  public getAdministrativeOfficerOptions(results) {
    return this.AdministrativeOfficerOptions;
  }

  /** Value sent to API: "Active" | "Inactive" | "All". */
  private getActiveStatusFilterForApi(): string {
    return this.activeStatusFilter.charAt(0).toUpperCase() + this.activeStatusFilter.slice(1);
  }

  public onActiveStatusFilterChange(): void {
    this.displayActive = this.activeStatusFilter !== "inactive";
    localStorage.setItem("displayActive", this.displayActive.toString());
    localStorage.setItem("activeStatusFilter", this.activeStatusFilter);
    this.tableSearchOrFilter(true);
  }

  public setSelectedFilters() {
    this.selectedInvestmentOfficers =
      this.gridOptions.grid.selectedInvestmentOfficers;
    this.selectedPortfolioManagers =
      this.gridOptions.grid.selectedPortfolioManagers;
    this.selectedAdministrativeOfficers =
      this.gridOptions.grid.selectedAdministrativeOfficers;
  }

  public getInvestmentOfficerOptions(results) {
    return this.InvestmentOfficerOptions;
  }

  public linkProfiles(clientNumber: string) {
    this.ModalService.showModal({
      templateUrl: "./app/clients/modaltemplates/linkprofiles.html",
      controller: "LinkProfileController",
      inputs: {
        clientNumber: clientNumber,
      },
    }).then(function (modal) {
      modal.element.modal({
        backgroud: "static",
        keyboard: false,
      });
    });
  }

  public updatePageOptions() {
    if (
      localStorage.getItem("currentPage") ||
      localStorage.getItem("itemsPerPage")
    ) {
      localStorage.setItem(
        "currentPage",
        this.gridOptions.grid.paginationOptions.currentPage
      );
      localStorage.setItem(
        "itemsPerPage",
        this.gridOptions.grid.paginationOptions.itemsPerPage
      );
      this.page = localStorage.getItem("currentPage");
      this.gridOptions.grid.paginationOptions.currentPage = this.page;
      this.itemsPerPage = localStorage.getItem("itemsPerPage");
      this.gridOptions.grid.paginationOptions.itemsPerPage = this.itemsPerPage;
    } else {
      localStorage.setItem(
        "currentPage",
        this.gridOptions.grid.paginationOptions.currentPage
      );
      localStorage.setItem(
        "itemsPerPage",
        this.gridOptions.grid.paginationOptions.itemsPerPage
      );
    }
  }

  public clearSearchTerm = () => {
    this.searchTerm = "";
    localStorage.setItem("searchTerm", this.searchTerm);
  };

  navigateToPortfolioManagement = (clientNumber) => {
    // If user has ClientDetailsViewOnly role, go to client details page
    if (this.authService.isClientDetailsViewOnly()) {
      this.$state.go("root.portfolioManagement.clients.detail", {
        id: clientNumber,
      });
    } else {
      this.$state.go("root.portfolioManagement.clients.portfolio", {
        clientNumber,
      });
    }
  };

  navigateToEditClient = (clientNumber) => {
    this.$state.go("root.portfolioManagement.clients.detail", {
      id: clientNumber,
    });
  };

  scrollToTopOfTable = () => {
    let table = document.querySelector("#clients-table");
    let tbody = table.querySelectorAll("tbody");
    tbody[0].scrollTop = 0;
  };

  public hasFiltersApplied(): boolean {
    return this.displayMyClients || this.activeStatusFilter !== "active" || !this.displayInstitutions || !this.displayIndividuals || 
           (this.selectedInvestmentOfficers && this.selectedInvestmentOfficers.length > 0) || 
           (this.selectedPortfolioManagers && this.selectedPortfolioManagers.length > 0) || 
           (this.selectedAdministrativeOfficers && this.selectedAdministrativeOfficers.length > 0) || 
           (this.selectedGeographicalLocations && this.selectedGeographicalLocations.length > 0) || 
           (this.selectedProfessionalActivities && this.selectedProfessionalActivities.length > 0);
  }

  public addNewClient() {
    this.$mdDialog.show({
      template: `
        <md-dialog flex="25">
          <client-type-selection-modal 
            on-create-client="$ctrl.onCreateClient(clientNumber)" 
            on-cancel="$ctrl.onCancelClientCreation()">
          </client-type-selection-modal>
        </md-dialog>
      `,
      controller: () => {
        return {
          onCreateClient: (clientNumber) => {
            this.$mdDialog.hide();
            this.navigateToNewClient(clientNumber);
          },
          onCancelClientCreation: () => {
            this.$mdDialog.hide();
          }
        };
      },
      controllerAs: '$ctrl'
    });
  }

  private navigateToNewClient(clientNumber: string) {
    console.log('navigateToNewClient', clientNumber);
    // Navigate to client details page with client number as id
    this.$state.go('root.portfolioManagement.clients.detail', { 
      id: clientNumber
    });
  }

  public openFilterModal() {

    // Use controller and controllerAs instead of custom scope
    this.$mdDialog.show({
      template: `
        <md-dialog flex="25">
          <clients-filter-modal 
            filters="$ctrl.currentFilters" 
            is-client-details-view-only="$ctrl.isClientDetailsViewOnly"
            on-filters-applied="$ctrl.onFiltersApplied(filters)" 
            on-filters-cancelled="$ctrl.onFiltersCancelled()">
          </clients-filter-modal>
        </md-dialog>
      `,
      controller: () => {
        return {
          isClientDetailsViewOnly: this.authService.isClientDetailsViewOnly(),
          currentFilters: {
            displayMyClients: this.displayMyClients,
            displayInstitutions: this.displayInstitutions,
            displayIndividuals: this.displayIndividuals,
            hasTradeRestrictions: this.hasTradeRestrictions,
            selectedGeographicalLocations: this.selectedGeographicalLocations,
            selectedProfessionalActivities: this.selectedProfessionalActivities,
            selectedSecurityRestrictions: this.selectedSecurityRestrictions
          } as ClientFilters,
          
          onFiltersApplied: (filters: ClientFilters) => {
            this.displayMyClients = filters.displayMyClients;
            this.displayInstitutions = filters.displayInstitutions;
            this.displayIndividuals = filters.displayIndividuals;
            this.hasTradeRestrictions = filters.hasTradeRestrictions || false;
            this.selectedGeographicalLocations = filters.selectedGeographicalLocations || [];
            this.selectedProfessionalActivities = filters.selectedProfessionalActivities || [];
            this.selectedSecurityRestrictions = filters.selectedSecurityRestrictions || [];

            // Update localStorage (active status is controlled by the table Status dropdown only)
            localStorage.setItem('displayMyClients', this.displayMyClients.toString());
            localStorage.setItem('displayInstitutions', this.displayInstitutions.toString());
            localStorage.setItem('displayIndividuals', this.displayIndividuals.toString());
            localStorage.setItem('hasTradeRestrictions', this.hasTradeRestrictions.toString());
            localStorage.setItem('selectedGeographicalLocations', JSON.stringify(this.selectedGeographicalLocations));
            localStorage.setItem('selectedProfessionalActivities', JSON.stringify(this.selectedProfessionalActivities));
            localStorage.setItem('selectedSecurityRestrictions', JSON.stringify(this.selectedSecurityRestrictions));
            
            this.tableSearchOrFilter(true);
            this.$mdDialog.hide();
          },
          
          onFiltersCancelled: () => {
            this.$mdDialog.cancel();
          }
        };
      },
      controllerAs: '$ctrl'
    });
  }

  // Role-based permission method - delegate to AuthService
  public canEditClients(): boolean {
    return this.authService.canEditClients();
  }

  public isClientDetailsViewOnly(): boolean {
    return this.authService.isClientDetailsViewOnly();
  }

  public exportToExcel() {
    // Show modal immediately with loading state
    this.$mdDialog.show({
      template: `
        <md-dialog flex="40">
          <client-export-columns-modal 
            on-export="$ctrl.onExport(exportParams)" 
            on-cancel="$ctrl.onCancel()">
          </client-export-columns-modal>
        </md-dialog>
      `,
      controller: () => {
        const controller = {
          onExport: (params: { selectedColumns: string[]; exportAllClients: boolean }) => {
            console.log('onExport', params);
            if (params) {
              this.performExport(params.selectedColumns, params.exportAllClients);
              this.$mdDialog.hide();
            }
          },
          onCancel: () => {
            this.$mdDialog.cancel();
          }
        };
        return controller;
      },
      controllerAs: '$ctrl'
    });
  }

  public extractRiskMatrixPep() {
    if (this.isExtractingPep) return;
    this.isExtractingPep = true;
    this.clientCRMRepo
      .extractDynamicsRiskMatrixPep()
      .then(() => {
        this.isExtractingPep = false;
        this.notifyjs('PEP extraction from Dynamics completed successfully.');
        this.tableSearchOrFilter(false);
      })
      .catch((err) => {
        this.isExtractingPep = false;
        this.notifyjs(extractErrorMessage(err, 'PEP extraction failed.'), 'error');
      });
  }

  private performExport(selectedColumns: string[], exportAllClients: boolean) {
    this.isLoading = true;
    
    // Build export request with filter params (if not exporting all)
    const exportRequest: any = {
      selectedColumns: selectedColumns,
      exportAllClients: exportAllClients
    };

    // Only include filter params if not exporting all clients
    if (!exportAllClients) {
      exportRequest.filterParams = {
        searchText: this.searchTerm,
        searchColumn: this.searchColumn,
        orderColumn: this.orderColumn,
        orderDirection: this.orderDirection,
        displayAllClients: !this.displayMyClients,
        selectedInvestmentOfficers: this.selectedInvestmentOfficers,
        selectedPortfolioManagers: this.selectedPortfolioManagers,
        selectedAdministrativeOfficers: this.selectedAdministrativeOfficers,
        selectedGeographicalLocations: this.selectedGeographicalLocations,
        selectedProfessionalActivities: this.selectedProfessionalActivities,
        selectedSecurityRestrictions: this.selectedSecurityRestrictions,
        hasTradeRestrictions: this.hasTradeRestrictions,
        activeStatusFilter: this.getActiveStatusFilterForApi(),
        displayActiveClients: this.displayActive,
        displayInstitutions: this.displayInstitutions,
        displayIndividuals: this.displayIndividuals
      };
    }
    
    this.clientRepo.exportClientsToExcel(exportRequest)
      .then((response: angular.IHttpPromiseCallbackArg<any>) => {
        // Response is a blob (Excel file)
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Get filename from Content-Disposition header or use default
        const contentDisposition = response.headers('Content-Disposition');
        let filename = 'ClientsExport.xlsx';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
          }
        }
        
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error('Error exporting clients:', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export const clients: angular.IComponentOptions = {
  template: require("./clients.html"),
  controller: ClientsController,
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.ts